import React from "react"
import classNames from "classnames"
import { Nav, Navbar, NavItem, NavDropdown, MenuItem } from "react-bootstrap"

var header = {__html:
   `
<header class="navbar navbar-inverse navbar-fixed-top navbar-my mytheme" role="banner">
        <div class="container ">
            <div class="navbar-header">
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>

                <div class="navbar-brand navbar-banner" height="100%"> 
                <a href="/">
                   <img style="float: left; margin-right: 10px;" height="36px" src="/img/banner.svg">
                </a>
                <a class="title-text" href="/">Datum</a>
                <p style="float: right;" class="navbar-text visible-lg">Going Beyond the Data</p>
                </div>
            </div>
            <div class="collapse navbar-collapse navbar-my">
               
<ul class="nav navbar-nav navbar-right navbar-my mytheme"><li class="" id="services-1"><a href="/services">
            Services
            
        </a></li><li class="
               " id="team-1"><a href="/team">
            Team
            
        </a></li><li class="
               " id="contact"><a href="mailto:info@datumco.io">
            Contact
            
        </a></li>
      
      </ul>

                
            </div>
        </div>
    </header><!--/header-->
      `}


var footer = {__html:
   `
<section id="bottom" class="mytheme" style="padding-top: 30px; padding-bottom: 30px;">
   <div class="container" style="width: 80%;">
      <div class="col-md-4 col-sm-12 center-outer">
         <img class="center" width=180px max-width=80% src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/sites/www.datumco.io/img/footer_icon.svg">
      </div><!--/.col-md-3-->
      <div class="col-md-4 col-sm-6 leftborder-gradient">
         <h4>About Us</h4>
         <p>We are a diverse group of Data Scientists with a broad array of domain knowledge and experience in building end-to-end machine learning applications.</p>
      </div><!--/.col-md-3-->


      <div class="col-md-4 col-sm-6 leftborder-gradient">
         <h4> Contact Us </h4>
         <a href="mailto:info@datumco.io"> Leave a message </a>
         <address>
            <br>
            <strong> Datum &#38; co.</strong><br>
            224 Townsend Street<br>
            San Francisco, CA 94107<br>
         </address>
         <script src="//platform.linkedin.com/in.js" type="text/javascript"> lang: en_US</script>
         <script type="IN/FollowCompany" data-id="17876828"></script>
      </div> <!--/.col-md-3-->
      
   </div>
</section>`}

const year = new Date().getFullYear();
   
const Footer_ = ({year}) => (
   <footer id="footer" className="mytheme-footer">
   <div class="container">
   <div class="row center">
         All rights reserved © Datum &amp; co. 2016-{year}
   <ul class="pull-right">
   <li><a id="gototop" class="gototop" href="#"><i class="icon-chevron-up"></i></a></li>
   </ul>
   </div>
   </div>
   </footer>
)



const MyNav = () => (
 <Navbar>
    <Navbar.Header>
      <Navbar.Brand>
        <a href="/"><img src={'/img/banner.svg'}/> </a>
      </Navbar.Brand>
      <Navbar.Toggle />
    </Navbar.Header>
      <Navbar.Collapse>
      <Nav>
        <NavItem eventKey={1} href="/services">Services</NavItem>
        <NavItem eventKey={1} href="/team">Team</NavItem>
        <NavItem eventKey={2} href="mailto:info@datumco.io">Contact</NavItem>
      </Nav>
      </Navbar.Collapse>
  </Navbar>
)

const Header = () => (
   // <div dangerouslySetInnerHTML={header} />
   <MyNav />
)

export const Footer = () => (
   <div>
      <div dangerouslySetInnerHTML={footer} />
      <Footer_ year={year} />
   </div>
)

export default Header



/** WEBPACK FOOTER **
 ** ./src/pages/header.js
 **/